import React from "react";
import { useParams } from "react-router";
import useProjectActions from "../hooks/useProjectActions";
import useFirebaseProject from "../hooks/useFirebaseProject";
import uuid from "react-uuid";

import MaterialForm from "./MaterialForm";

const MaterialAddPage = () => {
  const { id: project_id, order } = useParams();
  const { editProject } = useProjectActions();
  const project = useFirebaseProject(project_id!);

  const handleSubmit = (formValues: any) => {
    const new_project = { ...project };
    const new_material = { order: order, ...formValues, glass: project?.glass };
    const new_material_uuid = uuid();

    new_project.materials = {
      ...new_project.materials,
      [new_material_uuid]: new_material,
    };
    editProject(project_id!, new_project);
  };

  return (
    <div>
      <MaterialForm
        onSubmit={handleSubmit}
        initialValues={{
          description: "",
          glass_reference: "",
        }}
        glass_type={project?.glass}
      />
    </div>
  );
};

export default MaterialAddPage;
